// Shared email-optin form validation helpers. Extracted so every
// lead-capture form (LeadDialog, ChecklistOptin, GuideMidArticleOptin,
// ContactPage, SaveEstimate, DisasterQuoteCTA, RepublicationForm)
// shares the same inline-validation contract — replaces the native
// `required` tooltip UX which was killing conversions on mobile.
//
// Usage:
//   const [err, setErr] = useState("");
//   const invalid = validateEmail(email);
//   if (invalid) { setErr(invalid); track("optin_submit_attempted_with_errors", ...); return; }
//
// Regex is deliberately loose: rejects "foo", "foo@", "foo@bar" while
// accepting "a@b.c", "alice+tag@sub.example.co". Anything stricter
// rejects real edge cases (tag+alias@, non-.com TLDs).
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateEmail(raw, { requiredMsg = "Enter your email to continue.", invalidMsg = "That email doesn't look right. Try again?" } = {}) {
  const trimmed = (raw || "").trim();
  if (!trimmed) return requiredMsg;
  if (!EMAIL_RE.test(trimmed)) return invalidMsg;
  return "";
}

// Standard Tailwind classes for an input field in error state. Keeps
// the red state visually consistent across every form.
export const ERR_INPUT_CLS = "border-red-500 focus-visible:ring-red-500";

// Standard classes for the inline error message under an input.
export const ERR_MSG_CLS = "text-xs font-medium text-red-600";
